import React from "react";

import Copy from "copy-to-clipboard";
import PropTypes from "prop-types";
import { FormattedMessage, injectIntl, intlShape } from "react-intl";

import SharedIntlProviderHOC from "shared-components/hocs/sharedIntlProviderHOC";

import { getExternalAddress } from "../../../lib/url_utils";

class CopyEmailSocialButtons extends React.Component {
  constructor(props) {
    super(props);
    this.emailShare = this.emailShare.bind(this);
    this.copyLink = this.copyLink.bind(this);
    this.customUrl = this.customUrl.bind(this);

    this.state = {
      isCopied: false,
    };
  }

  copyLink(e) {
    e.preventDefault();

    const { listingData = {}, campaign = "", origin } = this.props;
    const { _id } = listingData;
    const prefix = SharedIntlProviderHOC.getUrlPrefix();
    const urlPrefix = prefix ? `/${prefix}` : "";
    const url = `${getExternalAddress()}${urlPrefix}/pages/listings/${_id}`;

    Copy(`${url}?utm_source=copy_link&utm_campaign=${campaign}`);

    analyticsIntegrations.shareBtnClick(listingData, origin, "copy link");

    this.setState(
      {
        isCopied: true,
      },
      () => {
        setTimeout(() => {
          this.setState({ isCopied: false });
        }, 1000);
      },
    );
  }

  emailShare(e) {
    e.preventDefault();
    const {
      listingData = {},
      campaign = "",
      emailSubject = "",
      intl,
      origin,
    } = this.props;
    const { _id, city, page_title: pageTitle } = listingData;
    const prefix = SharedIntlProviderHOC.getUrlPrefix();
    const urlPrefix = prefix ? `%2F${prefix}` : "";

    const emailUrl = `mailto:?subject=${emailSubject || intl.formatMessage({ id: "hosting.copy_email_social_buttons.email_subject", defaultMessage: "Check out this Peerspace location" })}&body=${intl.formatMessage({ id: "hosting.copy_email_social_buttons.email_body", defaultMessage: "{pageTitle} in {city} - {address}" }, { pageTitle: encodeURIComponent(pageTitle), city: city, address: encodeURIComponent(getExternalAddress()) })}${urlPrefix}%2Fpages%2Flistings%2F${_id}`;

    analyticsIntegrations.shareBtnClick(listingData, origin, "email");

    window.open(
      `${emailUrl}%3Futm_source%3Demail%26utm_campaign%3D${campaign}`,
      "_blank",
    );
  }

  customUrl() {
    const { listingData = {}, origin } = this.props;
    const { parentSpaceId } = listingData;

    analyticsIntegrations.shareBtnClick(listingData, origin, "custom_url");
    window.location.href = `/host/space-hub/${parentSpaceId}`;
  }

  render() {
    return (
      <div>
        <ul className="list-unstyled social-buttons">
          <li>
            <button
              className="btn btn-primary btn-block classic"
              id="copy-link"
              rel="nofollow"
              title="Email"
              onClick={this.copyLink}
            >
              <div>
                <span className="ico ico-md icon-link" />
                <span className="margin-sm-left">
                  {this.state.isCopied ? (
                    <FormattedMessage
                      id="hosting.copy_email_social_buttons.button_text_copied"
                      defaultMessage="Copied!"
                    />
                  ) : (
                    <FormattedMessage
                      id="hosting.copy_email_social_buttons.button_text_copy_link"
                      defaultMessage="Copy Link"
                    />
                  )}
                </span>
              </div>
            </button>
          </li>
          <li>
            <button
              onClick={this.emailShare}
              className="btn btn-block btn-outline classic email"
            >
              <i className="ico icon-mail-outline margin-md-right" />
              <span>
                <FormattedMessage
                  id="hosting.copy_email_social_buttons.button_text_email"
                  defaultMessage="Email"
                />
              </span>
            </button>
          </li>
          <li>
            <button
              onClick={this.customUrl}
              className="btn btn-default classic btn-block btn-outlined-light"
            >
              <FormattedMessage
                id="hosting.copy_email_social_buttons.button_text_custom_url"
                defaultMessage="Get custom URL"
              />
            </button>
          </li>
        </ul>
      </div>
    );
  }
}

CopyEmailSocialButtons.propTypes = {
  listingData: PropTypes.object,
  campaign: PropTypes.string,
  emailSubject: PropTypes.string,
  intl: intlShape,
};

export default injectIntl(CopyEmailSocialButtons);
